import React, { Component, Fragment } from 'react';
import authService from '../../services/AuthService';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import moment from 'moment-timezone';

import pdfDownloadImage from '../../content/pdfDownload.png';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class PaymentProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.userId,
            email: null,
            subscriptionId: null,
            customerProfileId: null,
            paymentProfileId: null,
            paymentService: null,
            subscriptionType: null,
            payPerUseGraceAmount: 0,
            payPerUseQuantity: 0,
            subscriptionIsPastDue: false,
            subscriptionGraceDate: null,
            subscriptionCcLast4: 9999,
            subscriptionCardType: null
        }

        this.needsUpdated = false;
    }

    componentDidMount() {

        // Run a query and get the current user subscription/ppu status
        let url = "account/" + this.props.userId + "/subscription";
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then(response => {
                if (response.status == 200) {

                    // Just bind the pertinent info.
                    this.setState({
                        userEmail: response.data.userEmail,
                        subscriptionId: response.data.subscriptionId,
                        customerProfileId: response.data.customerProfileId,
                        paymentProfileId: response.data.paymentProfileId,
                        paymentService: response.data.paymentService,
                        subscriptionType: response.data.subscriptionType,
                        payPerUseGraceAmount: response.data.payPerUseGraceAmount,
                        payPerUseQuantity: response.data.payPerUseQuantity,
                        subscriptionIsPastDue: response.data.subscriptionIsPastDue,
                        subscriptionGraceDate: response.data.subscriptionGraceDate,
                        subscriptionRenewalDate: response.data.subscriptionRenewalDate,
                        subscriptionCcLast4: response.data.subscriptionCcLast4,
                        subscriptionCardType: response.data.subscriptionCardType
                    })
                }
                else {
                    // Major problem - should not happen.  Back to login
                    apiErrorPopup(apiResponseHandler(response));
                }
            })
            .catch(error => {
                // Major problem - should not happen.  Back to login
                apiErrorPopup(apiErrorHandler(error));
                authService.setAuthenticated(null, null, 0, null, null, null, null, false, false, false, false, false, -1, null);
            });
    }

    render() {
        let subscriptionType = "Unknown";
        let firstName = authService.authenticatedUserFirstName;
        let lastName = authService.authenticatedUserLastName;

        switch (this.state.subscriptionType) {
            case "free":
                subscriptionType = "Free Account";
                break;
            case "trial":
                subscriptionType = "Trial Account";
                break;
            case "ppu":
                subscriptionType = "Pay Per Use";
                break;
            case "sub":
                subscriptionType = "Subscription";
                break;
        }


        let ppuStatus = "Active";
        let ppuClass = "profile_paymentStateGreen";
        if (subscriptionType == "Pay Per Use") {
            if (this.state.payPerUseQuantity == 0) {
                ppuStatus = "Time to purchase additional assessments!";
                ppuClass = "profile_paymentStateYellow";
            }
            else if (this.state.payPerUseQuantity < 0) {
                ppuStatus = "No additional assessments can be created until you purchase more!"
                ppuClass = "profile_paymentStateRed";
            }
        }

        let subStatus = "Active";
        let subClass = "profile_paymentStateGreen";
        let sRenewalDate = null;
        if (subscriptionType == "Subscription") {
            if (this.state.subscriptionIsPastDue) {
                subStatus = "NEEDS UPDATED";
                subClass = "profile_paymentStateRed";
            }

            if (!isNullOrEmpty(this.state.subscriptionRenewalDate)) {

                let mRenewalDate = moment.utc(this.state.subscriptionRenewalDate).tz(moment.tz.guess());
                sRenewalDate = mRenewalDate.format("MMM-DD-YYYY");
            }
        }

        let updateHref = "https://www.clearchildpsychology.com/square/update.php?cid=" + this.props.userId + "&fn=" + firstName + "&ln=" + lastName + "&em=" + this.state.userEmail + "&sub=" + this.state.subscriptionId + "&cst=" + this.state.customerProfileId;

        return (
            <Card>
                <Container>
                    <Form>

                        <h4 className="profile_GenInfoHdr">Account Profile</h4>
                            
                        <Row>
                            <Col sm={4}>
                                <Form.Label>Account Type</Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Form.Label>{subscriptionType}</Form.Label>
                            </Col>
                        </Row>
                        {this.state.subscriptionType == "ppu" &&
                            <Fragment>
                                <Row>
                                    <Col sm={4}>
                                        <Form.Label>Status</Form.Label>
                                    </Col>
                                    <Col sm={8}>
                                        <Form.Label className={ppuClass}>{ppuStatus}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <Form.Label>Assessments Remaining</Form.Label>
                                    </Col>
                                    <Col sm={8}>
                                        <Form.Label>{this.state.payPerUseQuantity}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <Form.Label>Purchase Additional Assessments</Form.Label>
                                    </Col>
                                    <Col sm={8}>
                                    <a className="profile_updateAccount" href={updateHref} target="_blank">Click to open purchase page</a>
                                    </Col>
                                </Row>
                            </Fragment>
                        }
                        {this.state.subscriptionType == "sub" &&
                            <Fragment>
                                <Row>
                                    <Col sm={4}>
                                        <Form.Label>Status</Form.Label>
                                    </Col>
                                    <Col sm={8}>
                                    <Form.Label className={subClass}>{subStatus}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <Form.Label>Auto Renewal Date</Form.Label>
                                    </Col>
                                    <Col sm={8}>
                                    <Form.Label>{sRenewalDate}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <Form.Label>Credit Card Type</Form.Label>
                                    </Col>
                                    <Col sm={8}>
                                        <Form.Label>{this.state.subscriptionCardType}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <Form.Label>Credit Card Last 4 Digits</Form.Label>
                                    </Col>
                                    <Col sm={8}>
                                    <Form.Label>{this.state.subscriptionCcLast4}</Form.Label>
                                    </Col>
                            </Row>
                            <Row>
                                <Col sm={4}>
                                    <Form.Label>Update Subscription</Form.Label>
                                </Col>
                                <Col sm={8}>
                                    <a href={updateHref} target="_blank">Click to update subscription</a>
                                </Col>
                            </Row>
                            </Fragment>
                        }
                        <p className="profile_notation">(You may need to exit and return to this tab in order to see purchase updates)</p>
                    </Form>
                </Container>
            </Card>
        )
    }
}

export default PaymentProfile;


// WEBPACK FOOTER //
// ./src/components/Profile/PaymentProfile.js